import React from "react";
import { useNavigate } from "react-router-dom";

export default function Finish() {
    const navigate = useNavigate();

    return (
        <div id='Finish'>
            <div className='big-title'>Expertenprofil</div>
            <div className='normal-text'>Ihre Daten wurden gespeichert.</div>
            <button className='button-red' onClick={() => navigate("/")}>
                Zurück zur Übersicht
            </button>
        </div>
    );
}
